import { render, staticRenderFns } from "./WorksVideoContainer.vue?vue&type=template&id=d0863050&scoped=true&"
import script from "./WorksVideoContainer.vue?vue&type=script&lang=js&"
export * from "./WorksVideoContainer.vue?vue&type=script&lang=js&"
import style0 from "./WorksVideoContainer.vue?vue&type=style&index=0&id=d0863050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0863050",
  null
  
)

export default component.exports